import React, { useEffect } from "react";
import Button from "../../../../ui/button/Button";
import history from "../../../../../utils/history";
import Panel from "../../../../ui/panel/Panel";
import Text from "../../../../ui/text/Text";
import "./FailedPaymentEmailTemplate.scss";
import { AppState } from "../../../../..";
import { useDispatch, useSelector } from "react-redux";
import { IAuthReducerState } from "../../../../../reducers/authReducer";
import { ICompanyBrandingReducerState } from "../../../../../reducers/companyBrandingReducer";
import { Row, Col } from "react-grid-system";
import EmailPreivewContainer from "../../brand-customization/email-preview/EmailPreivewContainer";
import BackNavigationPanel from "../../../../ui/back-navigation-panel/BackNavigationPanel";
import { IEmailCustomizationReducerState } from "../../../../../reducers/emailCustomizationReducer";
import { getEmailTemplateValues, resetEmailTemplateValues } from "../../../../../actions/emailCustomizationActions";
import EmailEditableArea from "../email-editable-area/EmailEditableArea";
import { EmailTypes } from "../../../../../utils/grpc/generated/Billsby.Protos/Messenger/private/emailconfig/emailconfig_pb";

const FailedPaymentEmailTemplate: React.FC = () => {
  const dispatch = useDispatch();
  const companyBrandingReducer = useSelector<AppState, ICompanyBrandingReducerState>(state => state.companyBrandingReducer);
  const emailCustomizationReducer = useSelector<AppState, IEmailCustomizationReducerState>(state => state.emailCustomizationReducer);
  const authReducer = useSelector<AppState, IAuthReducerState>(state => state.auth);

  const { customArea1, customArea2, customArea3 } = emailCustomizationReducer;
  const { currentCompanyId, companyName } = authReducer;
  const { highlightColor } = companyBrandingReducer;
  const defaultHighLightColor = "#F87847";

  useEffect(() => {
    dispatch(getEmailTemplateValues(currentCompanyId as number, companyName, EmailTypes.PAYMENT_FAILURE_INITIAL));
    return () => { dispatch(resetEmailTemplateValues()) };
  }, []);
  
  return (
    <div>
      <BackNavigationPanel
        title={"DUNNING_FAILED_PAYMENTS_INITIAL_PAYMENT_FAILURE_TITLE"} shouldTranslateTitle={true}
        onClick={() => history.push("/configuration/dunning-process/failed")} />

      <Row>
        <Col sm={8}>
          <Panel className="declined-payment-email-template__panel" noMargin>
            <EmailPreivewContainer>

              <Text
                content="DECLINED_PAYMENTS_EMAIL_TEMPLATE_GREETINGS"
                className="email-preview__details__text"
                component="span"
                noMargin
              />

              <Text
                content={<span dangerouslySetInnerHTML={{__html: customArea1}}></span>}
                shouldTranslate={false}
                className="email-preview__details__text bar bar-blue"
                component="span"
                noMargin
              />

              <Text
                content="DECLINED_PAYMENTS_EMAIL_TEMPLATE_REATTEMPT_THE_PAYMENT"
                className="email-preview__details__text"
                component="span"
                noMargin
              />

              <div className="email-preview__details__button">
                <Button
                  id="select-plan-continue"
                  type="button"
                  className="email-preview__details__button-orange declined-payment-email-template__button"
                  title="DECLINED_PAYMENTS_EMAIL_TEMPLATE_REATTEMPT_BUTTON"
                  style={{ backgroundColor: !!highlightColor ? highlightColor : defaultHighLightColor }}
                />
              </div>

              <Text  
                style={{ color: !!highlightColor ? highlightColor : defaultHighLightColor }}
                content="DECLINED_PAYMENTS_EMAIL_TEMPLATE_VIEW_INVOICE"
                className="email-preview__details__text email-preview__details__text-center email-preview__details__text-underlined"
                component="span"
                noMargin
              />

              <Text
                content="DECLINED_PAYMENTS_EMAIL_TEMPLATE_REAGRDS"
                className="email-preview__details__text"
                component="span"
                noMargin
              />

              <Text
                content={companyName}
                className="email-preview__details__text"
                component="span"
                shouldTranslate={false}
                noMargin
              />
            </EmailPreivewContainer>
          </Panel>
        </Col>
        <Col sm={4}>
        <EmailEditableArea
            id="FailedPaymentEmailTemplate"
            emailCustomCopyOneValue={customArea1}
            emailCustomCopyTwoValue={customArea2}
            emailCustomCopyThreeValue={customArea3}
            emailCustomCopyTwoIsVisible={false}
            emailCustomCopyThreeIsVisible={false}
            showCompanyAlertToggle={true}
            showProductAlertToggle={true}
            showPlanAlertToggle={true}
            emailAdsIsVisible={false}
          />
        </Col>
      </Row>
    </div>
  )
}

export default FailedPaymentEmailTemplate;